<template>
    <div>
        <report-header
            :title="title"
            :isLoading="isLoading"
            :reportPagination="pagination"
        />
        <b-card>
            <div class="mb-4">
                <div id="report-body" class="w-100">
                    <QTable
                        :columns="columns"
                        :data="results"
                        hide-bottom
                        :loading="isLoading"
                        class="mb-4"
                        :rows-per-page-options="[0]"
                    >
                        <template
                            v-slot:bottom-row
                            v-if="results.length == 0 && !isLoading && !isError"
                        >
                            <q-tr>
                                <q-td colspan="12">No records available</q-td>
                            </q-tr>
                        </template>
                        <template v-slot:body-cell-appointment_date="props">
                            <q-td :props="props" class="">
                                <appointment-date
                                    :use-router="true"
                                    :appointment="
                                        generateAppointmentDateObject(props.row)
                                    "
                                />
                            </q-td>
                        </template>
                        <template v-slot:body-cell-client="props">
                            <q-td :props="props" class="">
                                <client-name
                                    :use-router="USE_CLIENT_MODULE_VUE"
                                    :client="generateClientObject(props.row)"
                                />
                            </q-td>
                        </template>
                        <template v-slot:body-cell-patient="props">
                            <q-td :props="props" class="">
                                <patient-name
                                    :use-router="USE_PATIENT_MODULE_VUE"
                                    :patient="generatePatientObject(props.row)"
                                    :show-status="true"
                                />
                            </q-td>
                        </template>
                    </QTable>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
const REPORT_NAME = "Pending Appointments";
import { QTable } from "quasar";
import Report from "@/mixins/report";
import AppointmentDate from "@/components/commons/appointment-date";
import ClientName from "@/components/commons/client-name";
import PatientName from "@/components/commons/patient-name";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
export default {
    mixins: [Report],
    components: {
        QTable,
        AppointmentDate,
        ClientName,
        PatientName,
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("month"),
                    end: this.getEndDate("day")
                };
            }
        }
    },
    data() {
        return {
            title: REPORT_NAME,
            meta: "",
            isLoading: true,
            isError: false,
            locale: "en-US",
            pagination: this.DEFAULT_PAGINATION(),
            results: [],
            isDestroyed: false,
            columns: [
                {
                    name: "requested",
                    field: row => row.requested,
                    format: (val, row) => {
                        return this._toDateTime(
                            parseFloat(row.requested)
                        ).toFormat(this._getLuxonFormat());
                    },
                    label: "Requested",
                    align: "left",
                    headerStyle: "width:10%",
                    style: "vertical-align: top;"
                },
                {
                    name: "appointment_date",
                    field: "appointment_date",
                    label: "Appointment Date",
                    align: "left",
                    headerStyle: "width:15%",
                    style: "vertical-align: top;"
                },
                {
                    name: "type",
                    field: "type",
                    label: "Type",
                    align: "left",
                    headerStyle: "width:15%",
                    style: "vertical-align: top;"
                },
                {
                    name: "assigned_to",
                    field: "assigned_to",
                    label: "Assigned To",
                    align: "left",
                    headerStyle: "width:10%",
                    style: "vertical-align: top;"
                },
                {
                    name: "client",
                    field: "client",
                    label: "Client",
                    align: "left",
                    headerStyle: "width:10%",
                    style: "vertical-align: top;"
                },
                {
                    name: "patient",
                    field: "patient",
                    label: "Patient",
                    align: "left",
                    headerStyle: "width:10%",
                    style: "vertical-align: top;"
                },
                {
                    name: "breed_species",
                    field: "breed_species",
                    label: "Breed (Species)",
                    align: "left",
                    headerStyle: "width:20%",
                    style: "vertical-align: top;"
                },
                {
                    name: "notes",
                    field: "notes",
                    label: "Notes",
                    align: "left",
                    headerStyle: "width:15%",
                    style: "vertical-align: top;"
                }
            ]
        };
    },
    mounted() {
        let self = this;
        self.results = [];
        self.data.start = self.getStartDate("month");
        self.data.end = self.getEndDate("month");
        self.data.filterDateOption = false;
        self.data.refreshOption = false;
        self._getSetting().then(() => {
            self.init();
        });
        window.scrollTo(0, 0);
    },
    methods: {
        async init(params) {
            let self = this;
            self.isLoading = true;
            self.isError = false;
            clearInterval(self.pagination.interval);
            self.loadingPercentages();

            let reportParams = {
                page: self.pagination.page,
                perPage: self.RECORD_PER_PAGE,
                from: params ? params.from : self.data.start.unix(),
                to: params ? params.to : self.data.end.unix()
            };

            await ReportService.getReport(
                CREPORT.TYPE.PENDING_APPOINTMENTS,
                reportParams
            )
                .then(response => {
                    const reportResponse = response.resource;
                    const length = reportResponse.results.length;

                    if (
                        response &&
                        response.message &&
                        response.message.code === 200
                    ) {
                        self.meta = reportResponse.meta;
                        if (self.pagination.page == 1) {
                            self.title = self.capitalize(self.meta.title);
                            self.dynamicPageTitle(self.title);
                        }

                        self.pagination.lastPage = reportResponse.meta.lastPage;
                        self.pagination.page++;

                        if (length > 0) {
                            // Combining new array with results
                            self.results = [
                                ...self.results,
                                ...reportResponse.results
                            ];
                        }
                    }

                    if (self.pagination.page <= self.pagination.lastPage) {
                        self.timer(self.INTERVAL_TIME).then(() => {
                            self.init();
                        });
                    } else {
                        self.loadingCompleted();
                        self.isLoading = false;
                    }
                })
                .catch(e => {
                    console.error(e);
                    self._message("Error: Unable to get the report.", "danger");
                    self.isLoading = true;
                    self.isError = true;
                });
        },
        generateAppointmentDateObject(row) {
            return {
                id: row.appointment_id,
                start: row.appointment_date,
                sort_date: row.appointment_date,
                type: "MEDICAL",
                is_active: row.assigned_to ? row.isactive : false,
                openNewTab: true
            };
        },
        generatePatientObject(row) {
            return {
                name:
                    row.patient && row.patient.name
                        ? this.capitalize(row.patient.name)
                        : "",
                encodedId:
                    row.patient && row.patient.encoded_id
                        ? row.patient.encoded_id
                        : "",
                isactive: true
            };
        },
        generateClientObject(row) {
            const isDeleted =
                row.client && row.client.label
                    ? this.capitalize(row.client.label).includes("(deleted)") ||
                      row.client_id == null
                    : null;
            return {
                id: isDeleted
                    ? null
                    : row.client && row.client.id
                    ? row.client.id
                    : null,
                name:
                    row.client && row.client.label
                        ? this.capitalize(
                              row.client.label.replace("(deleted)", "")
                          )
                        : null,
                encoded_id: isDeleted
                    ? null
                    : row.client && row.client.encoded_id
                    ? row.client.encoded_id
                    : null,
                isactive: !isDeleted
            };
        }
    },
    beforeDestroy: function () {
        let self = this;
        self.isDestroyed = true;
        self.data.filterDateOption = true;
        self.data.refreshOption = false;
    }
};
</script>
